const Book = () => (
  <svg
    width="44px"
    height="48px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.004 4.667h-4.46V2.489c0-.691-.198-1.236-.596-1.633C32.55.458 32.023.26 31.367.26c-.692 0-1.236.198-1.634.596-.397.397-.596.942-.596 1.633v2.178H15.863V2.489c0-.691-.198-1.236-.596-1.633C14.87.458 14.325.26 13.634.26c-.657 0-1.184.198-1.582.596-.397.397-.596.942-.596 1.633v2.178H6.997c-1.867 0-3.44.64-4.718 1.918C.999 7.865.36 9.437.36 11.304V42.31c0 1.867.64 3.44 1.919 4.719 1.279 1.278 2.851 1.918 4.718 1.918h31.007c1.866 0 3.439-.64 4.718-1.918 1.279-1.28 1.918-2.852 1.918-4.719V11.304c0-1.867-.64-3.44-1.918-4.719-1.28-1.279-2.852-1.918-4.718-1.918ZM6.997 9.126h4.46v2.178c0 .691.198 1.235.595 1.633.398.398.925.596 1.582.596.691 0 1.236-.198 1.633-.596.398-.398.596-.942.596-1.633V9.126h13.274v2.178c0 .691.199 1.235.596 1.633.398.398.942.596 1.634.596.656 0 1.183-.198 1.581-.596.398-.398.596-.942.596-1.633V9.126h4.46c.656 0 1.183.199 1.58.596.398.398.597.925.597 1.582v6.636H4.82v-6.636c0-.657.199-1.184.597-1.582.397-.397.924-.596 1.58-.596Zm31.007 35.362H6.997c-.657 0-1.184-.199-1.581-.596-.398-.398-.597-.925-.597-1.582V22.4h35.362v19.91c0 .657-.199 1.184-.596 1.582-.398.397-.925.596-1.581.596Z"
      fill="#5FA3A9"
    />
  </svg>
);

export default Book;
